import styled, { css } from 'styled-components';

export const TagsWrapper = styled.div`
 ${({ tags }) => !!tags && css`
    background-color: #EBEBEB;
    box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.1);
  `}
  border-radius: 8px;
  height: 16px;
  width: auto;
  min-width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  position: absolute;
  top: 8px;
  right: 8px;
`;
